import React from 'react';
import PropTypes from 'prop-types';
import { ComponentLoader } from './ComponentLoader/ComponentLoader';

/**
 * HeartWrapper Component Loader (dibs-portfolio-heart)
 */
const importFunc = () => {
    return import(/* webpackChunkName: "HeartWrapper" */
    'dibs-portfolio-heart').then(({ HeartWrapper }) => HeartWrapper);
};

export function HeartWrapperLoader(props) {
    return (
        <ComponentLoader
            {...props}
            load={props.load}
            importFunc={importFunc}
            useLoadingComponent={false}
        />
    );
}

HeartWrapperLoader.propTypes = {
    load: PropTypes.bool.isRequired,
};
